import { Alert, AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, AlertIcon, Badge, Box, Breadcrumb, BreadcrumbItem, BreadcrumbLink, Button, Card, CardBody, CardHeader, Checkbox, Container, Flex, FormControl, FormLabel, Grid, IconButton, Image, Input, InputGroup, InputLeftElement, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Select, Stack, Text, Textarea, useColorModeValue, useDisclosure, useToast } from '@chakra-ui/react'
import React, { useCallback, useEffect, useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { useStateContext } from '../../../context/ContextProvider';
import axiosClient from '../../../axios-client';
import { DeleteIcon, EditIcon, SearchIcon } from '@chakra-ui/icons';
import FloatingPlusButton from '../../../components/FloatingPlusButton';
import empty from '../../../assets/images/bell.png'
import Lottie from 'react-lottie';
import { useTranslation } from 'react-i18next';
import MyPagination from '../../../components/MyPagination';
import { useDebounce } from '../../../hooks/useDebounce';

// const defaultOptions = {
//     loop: true,
//     autoplay: true,
//     animationData: animationData,
//     rendererSettings: {
//         preserveAspectRatio: 'xMidYMid slice'
//     }
// };

function GestNotes() {
    const navigate = useNavigate()
    const { t } = useTranslation();
    const [loadingData, setLoadingData] = useState()

    const { user, setUser, currentBusiness } = useStateContext();
    const [notesData, setNotesData] = useState([]);
    const [businessesList, setBusinessesList] = useState([]);
    const [selectedBusiness, setSelectedBusiness] = useState('');
    const [currentPage, setCurrentPage] = useState(0);
    const [id, setId] = useState(null);
    const toast = useToast()
    const cancelRef = React.useRef()
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [message, setMessage] = useState('');
    const [noteData, setNoteData] = useState();
    const [noteId, setNoteId] = useState('');

    const [title, setTitle] = useState('');
    const [content, setContent] = useState('');

    const [selectedCible, setSelectedCible] = useState(null);
    const [selectedC, setSelectedC] = useState('');
    const [usersList, setUsersList] = useState([]);
    const [selectedUserCible, setSelectedUserCible] = useState('');
    const [checkLengthData, setCheckLengthData] = useState(false)

    //search variable
    const [searchTerm, setSearchTerm] = useState('');
    const debouncedSearchTerm = useDebounce(searchTerm, 500);

    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const [changeModal, setChangeModal] = useState(true)
    const [date, setDate] = useState("")

    const [selectedIds, setSelectedIds] = useState([]);
    const [isBulkAlert, setIsBulkAlert] = useState(false);

    const onOpenAlert = () => {
        setIsAlertOpen(true);
    };
    const onCloseAlert = () => {
        setIsAlertOpen(false);
        setIsBulkAlert(false);
    };

    const handleCibleChange = (ev) => {
        const role = ev.target.value;
        setSelectedCible(role)
        setSelectedUserCible('') // Reset selected user when role changes
        
        if (role && role !== 'All') {
            axiosClient.get(`/clients/getClientUsers/?role=${role}&id=${user.id}&page_size=100`)
                .then((res) => {
                    setUsersList(res.data.results || []);
                })
                .catch(() => {});
        } else {
            setUsersList([]);
        }
    }
    const [paginationData, setPaginationData] = useState()

    ////////////////////////////////the size of the table//////////////////////////////
    const PAGE_SIZE = 5;
    const [pageSize, setPageSize] = useState(PAGE_SIZE);
    const handlePageSizeChange = (event) => {
        const newSize = parseInt(event.target.value, 10);
        setPageSize(newSize);
        setCurrentPage(0);
    };
    //////////////////////////////////////////////////////////////////////////////////

    useEffect(() => {
        setSelectedIds([]);
    }, [pageSize, currentPage, searchTerm, selectedC, date]);

    useEffect(() => {
        axiosClient.get('/businesses/all/?page_size=50').then(res => {
            const list = res.data?.results ?? res.data;
            setBusinessesList(Array.isArray(list) ? list.filter((b) => !b.is_deleted) : []);
        }).catch(() => {});
    }, []);


    //get the data
    const fetchData = useCallback(async (signal) => {
        if (!user) return;
        try {
            setLoadingData(true);
            const response = await axiosClient.get(
                `/notes/getAllNotes/?page_size=${pageSize}&page=${currentPage + 1}&search_term=${debouncedSearchTerm}&cible=${selectedC}&userId=${user.id}&date=${date}&business=${currentBusiness?.id}`,
                { signal }
            );
            let filteredData = response.data.results || [];
            setPaginationData(response.data);

            if (filteredData.length === 0) {
                setNotesData([]);
                setCheckLengthData(true);
            } else {
                setNotesData(filteredData);
                setCheckLengthData(false);
            }
        } catch (error) {
            if (error.name !== 'CanceledError' && error.message !== 'canceled') {
                // console.error(error);
            }
        } finally {
            setLoadingData(false);
        }
    }, [pageSize, currentPage, debouncedSearchTerm, selectedC, user?.id, date, currentBusiness?.id]);

    useEffect(() => {
        const abortController = new AbortController();
        if (user) {
            fetchData(abortController.signal);
        }
        return () => abortController.abort();
    }, [fetchData, user]);

    function update() {
        fetchData();
    }

    const handleDelete = (id) => {
        if (!id) return;
        axiosClient.delete(`/notes/${id}/`)
            .then((response) => {
                setNotesData((prevData) => prevData.filter((row) => row.id !== id));
                // setNotesData(notesData.filter((row) => row.id !== id));
                toast({
                    description: t("la note est supprimée avec succès"),
                    status: 'warning',
                    duration: 2000,
                    isClosable: true,
                    position: 'bottom-right',
                    variant: 'left-accent',
                })
            })
            .catch((error) => {
                // // console.error(error);
            });
        onCloseAlert()
    }

    const handleBulkDelete = () => {
        if (selectedIds.length === 0) return;
        axiosClient.post('/notes/bulk_delete/', { ids: selectedIds })
            .then((response) => {
                setNotesData((prevData) => prevData.filter((row) => !selectedIds.includes(row.id)));
                setSelectedIds([]);
                toast({
                    description: t("Les notes sélectionnées ont été supprimées avec succès"),
                    status: 'warning',
                    duration: 2000,
                    isClosable: true,
                    position: 'bottom-right',
                    variant: 'left-accent',
                })
                update()
            })
            .catch((error) => {
                // console.error(error);
            });
        onCloseAlert()
    }

    const AjoutNote = () => {
        if (!title || title.trim() === "") {
            setMessage(t("Veuillez remplir le titre"))
            return;
        }
        if (!content || content.trim() === "") {
            setMessage(t("Veuillez remplir le contenu"))
            return;
        }
        const formData = new FormData()
        formData.append("title", title)
        formData.append("cible", selectedCible)
        formData.append("content", content)
        formData.append("added_by", user.id)
        if (selectedUserCible) {
            formData.append("utilisateur_ciblé", selectedUserCible)
        }
        if (selectedBusiness) {
            formData.append("business", selectedBusiness)
        }

        axiosClient.post('/notes/', formData)
            .then((response) => {
                setNotesData([response.data, ...notesData]);
                setTitle('')
                setContent('')
                setSelectedCible('')
                setSelectedBusiness('')
                setMessage("")
                update()
                toast({
                    description: t(`La note est ajoutée avec succès`),
                    status: 'success',
                    duration: 2000,
                    isClosable: true,
                    variant: 'left-accent',
                })
            })
        onClose()
        update()
    }

    const UpdateNote = (id) => {

        const formData = new FormData();
        if (title) formData.append("title", title)
        if (selectedCible) formData.append("cible", selectedCible)
        if (content) formData.append("content", content)
        if (selectedUserCible) formData.append("utilisateur_ciblé", selectedUserCible)
        if (selectedBusiness) formData.append("business", selectedBusiness)
        else formData.append("business", "")

        axiosClient.patch(`/notes/${id}/`, formData).then(() => {

            update()

            toast({
                description: t(`La note est modifiée avec succès`),
                status: 'success',
                duration: 2000,
                isClosable: true,
                variant: 'left-accent',
            })
            setTitle('')
            setContent('')
            setSelectedCible('')
            setSelectedBusiness('')
            setMessage("")
        })

        onClose()
    }
    const myColor = useColorModeValue("white", "gray.700");
    const borderColor = useColorModeValue("gray.300", "gray.600");
    const hoverDeleteBtn = useColorModeValue("red.50", "gray.600");
    const DeleteBtnIcon = useColorModeValue("red.400", "red.300");

    return (
        <Box position={"relative"}>
            <FloatingPlusButton tooltip={t("Ajouter une note")} onClick={() => {
                setSelectedCible('')
                setSelectedUserCible('')
                setSelectedBusiness(currentBusiness?.id || '')
                onOpen()
                setChangeModal(true)
            }} />
            <Flex>
                <Box w="100%" display={"flex"} justifyContent="space-between" flexDirection={{ base: 'column', md: "row" }} mt={2} mb={{ base: 0, md: 5 }}>
                    <Breadcrumb  fontStyle={"normal"} fontSize={{ base: "14px", sm: "14px", lg: "15px" }} color="gray.400" letterSpacing="-0.01em">
                        <BreadcrumbItem>
                            <BreadcrumbLink onClick={() => navigate('/')}>{t("Accueil")}</BreadcrumbLink>
                        </BreadcrumbItem>

                        <BreadcrumbItem isCurrentPage>
                            <BreadcrumbLink>{t("Notes")}</BreadcrumbLink>
                        </BreadcrumbItem>
                    </Breadcrumb>
                </Box>

            </Flex>
            {(notesData.length === 0 && !searchTerm && !selectedC && !date) ? (
                <Flex mb={'10'} mt={20} flexDirection={'column'} align={'center'} justify={'center'}>
                    <Image
                        height={150} width={150}
                        rounded={'md'}
                        alt={'empty'}
                        src={
                            empty
                        }
                        objectFit={'empty'}
                    />
                    <Text mt={10} color={"#aeaeae"}>{t("Il n'y a pas de notes à afficher")}</Text>
                </Flex>) :



                <Flex
                    direction={{ base: 'column', md: 'row' }}
                    align={{ base: 'stretch', md: 'center' }}
                    justify={'center'}
                    p={{ base: 1, sm: 5 }}
                    gap={10}
                >

                    <Flex
                        direction="column"
                        justify={{ base: 'flex-start', md: 'space-between' }}
                        width={{ base: "100%", lg: "70%" }}
                    >
                        <Flex
                            justifyContent="end"
                            alignItems="center"
                            direction={{ base: 'column', md: 'row' }}
                            mb={{ base: 2, md: 4 }}
                        >
                            <Input mr={{ base: 0, md: 5 }} mb={4} borderRadius={"5"} borderColor={borderColor} onChange={e => {
                                setCurrentPage(0);
                                setDate(e.target.value);
                            }} w={{ base: '100%', md: '30%' }} placeholder={t("Select Date")} size='md' type='month' />

                            <Select borderRadius={"5"} borderColor={borderColor} fontSize={{ base: 13, lg: 16 }} size={"md"} w={{ base: '100%', md: "30%" }} mr={{ base: 0, md: 5 }} mb={4} value={selectedC} onChange={(e) => setSelectedC(e.target.value)}>
                                <option value="">{t("Tout")}</option>
                                {user.role === "AdminClient" && <option value="ManagerClient">{t("Manager")}</option>}

                                <option value="RespoSuiviClient">{t("Centre d'appel")}</option>
                                <option value="StockManagerClient">{t("Gestionnaire de stock")}</option>
                                <option value="All">{t("Tous les membres")}</option>
                            </Select>
                            <InputGroup size={"md"} w={{ base: '100%', md: "40%" }}>
                                <InputLeftElement
                                    pointerEvents='none'
                                    children={<SearchIcon color='gray.300' />}
                                />
                                <Input
                                    borderRadius={"5"}
                                    placeholder={t("Recherche...")}
                                    value={searchTerm}
                                    borderColor={borderColor}
                                    onChange={(e) => {
                                        setCurrentPage(0)
                                        setSearchTerm(e.target.value)
                                    }}
                                    mb={4}
                                    sx={{
                                        marginLeft: 'auto',
                                    }}
                                />  </InputGroup>

                        </Flex>

                        {user.role === "AdminClient" && notesData.length > 0 && (
                            <Flex align="center" justify="space-between" mb={4} px={2}>
                                <Checkbox
                                    isChecked={notesData.length > 0 && selectedIds.length === notesData.length}
                                    isIndeterminate={selectedIds.length > 0 && selectedIds.length < notesData.length}
                                    onChange={(e) => {
                                        if (e.target.checked) {
                                            setSelectedIds(notesData.map(row => row.id));
                                        } else {
                                            setSelectedIds([]);
                                        }
                                    }}
                                    colorScheme="purple"
                                >
                                    {t("Tout sélectionner")}
                                </Checkbox>
                                {selectedIds.length > 0 && (
                                    <Button
                                        size="sm"
                                        colorScheme="red"
                                        leftIcon={<DeleteIcon />}
                                        onClick={() => {
                                            setIsBulkAlert(true);
                                            onOpenAlert();
                                        }}
                                    >
                                        {t("Supprimer sélection")} ({selectedIds.length})
                                    </Button>
                                )}
                            </Flex>
                        )}

                        {(notesData.length > 0) &&
                            notesData.map((row) => (

                                <Stack
                                    bg={myColor}
                                    mb={4}
                                    rounded={'lg'}
                                    p={6}
                                    boxShadow={'md'}
                                    alignItems={'start'}
                                    justify="space-between"
                                // as={"Button"}

                                >
                                    <Flex direction="row"
                                        justify="space-between"
                                        ml={'auto'}
                                        width="full">
                                        <Stack display={'flex'} flexDirection={{ base: "column", md: "row" }} align={'center'} flex={1} minW={0} mr={4}>
                                            {user.role === "AdminClient" && (
                                                <Checkbox
                                                    isChecked={selectedIds.includes(row.id)}
                                                    onChange={(e) => {
                                                        e.stopPropagation();
                                                        if (e.target.checked) {
                                                            setSelectedIds(prev => [...prev, row.id]);
                                                        } else {
                                                            setSelectedIds(prev => prev.filter(id => id !== row.id));
                                                        }
                                                    }}
                                                    mr={3}
                                                    colorScheme="purple"
                                                />
                                            )}
                                            <Text fontSize={'lg'} fontWeight="semibold" noOfLines={1} flex={1} minW={0}>{row.title}</Text>
                                        </Stack>
                                        <Flex align={"center"} flexWrap={"wrap"} gap={2} justifyContent="flex-end">
                                            <Badge
                                                px={3}
                                                py={1}
                                                rounded={'lg'}
                                                width="max-content"
                                                colorScheme={row.cible === "ManagerClient" ? "blue" :
                                                    row.cible === "RespoSuiviClient" ? "green" :
                                                        row.cible === "StockManagerClient" ? "yellow" : row.cible === "All" ? "pink" : ""}
                                            >
                                                {row.cible === "ManagerClient" ? "Manager" :
                                                    row.cible === "RespoSuiviClient" ? t("Centre d'appel") :
                                                        row.cible === "StockManagerClient" ? t(`Gestionnaire de stock`) : row.cible === "All" ? t(`Tout`) : ""}
                                            </Badge>
                                            {row.utilisateur_cible_nom && (
                                                <Badge px={3} py={1} rounded={'lg'} width="max-content" colorScheme="purple">
                                                    {row.utilisateur_cible_prenom} {row.utilisateur_cible_nom}
                                                </Badge>
                                            )}
                                            {row.business_name && (
                                                <Badge px={3} py={1} rounded={'lg'} width="max-content" colorScheme="teal">
                                                    {row.business_name}
                                                </Badge>
                                            )}
                                            <Text fontSize={'xs'} color={'gray.500'}>{new Date(row.date_creation).toLocaleDateString(t('fr-FR'), { hour: '2-digit', minute: '2-digit' })}</Text>
                                            {(user.role === "AdminClient") &&
                                                <Stack
                                                    color={DeleteBtnIcon}
                                                    onClick={() => {
                                                        setId(row.id);
                                                        setIsBulkAlert(false);
                                                        onOpenAlert();
                                                    }}
                                                    cursor='pointer'
                                                    p={3}
                                                    rounded={"full"}
                                                    _hover={{ bg: hoverDeleteBtn }}
                                                    ml={2}
                                                >
                                                    <DeleteIcon
                                                        size="sm"
                                                    />
                                                </Stack>
                                            }
                                        </Flex>


                                    </Flex>

                                    <Flex
                                        direction="row"
                                        width="full"
                                        ml={'auto'}
                                        maxHeight={"150px"}
                                        overflowY={"auto"}
                                        pr={2}
                                        justify="space-between">
                                        <Text fontSize={{ base: 'sm' }} textAlign={'justify'} w={"100%"}>
                                            {row.content}

                                        </Text>


                                    </Flex>
                                </Stack>
                            ))}
                        {((searchTerm && notesData.length === 0) || (date && notesData.length === 0) || (selectedC && notesData.length === 0) || (checkLengthData)) && (
                            <Flex alignItems={'center'}>
                                <Text >{t("Aucune note correspondante n'a été trouvée.")}</Text>
                            </Flex>

                        )}

                        {/* //////////////////////////////////////////Pagination////////////////////////////////////////// */}
                        <Flex flexDirection={{ base: 'column', lg: "row" }} justify="space-between" align="center" w="100%">
                            <Box flex="1">
                                <MyPagination
                                    paginationData={paginationData}
                                    currentPage={currentPage}
                                    setCurrentPage={setCurrentPage}
                                    PAGE_SIZE={pageSize}
                                />
                            </Box>

                            <Select rounded={"md"} size={"sm"} w="70px" value={pageSize} onChange={handlePageSizeChange}>
                                <option value="10">10</option>
                                <option value="20">20</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </Select>
                        </Flex>
                        {/* //////////////////////////////////////////Pagination////////////////////////////////////////// */}

                    </Flex>


                </Flex>
            }

            <AlertDialog
                isOpen={isAlertOpen}
                leastDestructiveRef={cancelRef}
                onClose={onCloseAlert}
            >
                <AlertDialogOverlay>
                    <AlertDialogContent>
                        <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                            {t("Supprimer")}
                        </AlertDialogHeader>

                        <AlertDialogBody>
                            {isBulkAlert 
                                ? t("êtes-vous sûr de vouloir supprimer les notes sélectionnées ? Vous ne pourrez pas annuler cette action ultérieurement.")
                                : t("êtes-vous sûr ? Vous ne pourrez pas annuler cette action ultérieurement.")}
                        </AlertDialogBody>

                        <AlertDialogFooter>
                            <Button ref={cancelRef} onClick={onCloseAlert}>
                                {t("Annuler")}
                            </Button>
                            <Button onClick={isBulkAlert ? handleBulkDelete : () => handleDelete(id)} colorScheme='red' ml={3}>
                                {t("Supprimer")}
                            </Button>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog>
            {changeModal ?
                <Modal isOpen={isOpen} onClose={() => {
                    onClose()
                    setMessage('')
                    setSelectedCible('')
                    setSelectedBusiness('')
                    setTitle('')
                    setContent('')
                    setSelectedCible('')
                }}>
                    <ModalOverlay />

                    <ModalContent>

                        <ModalHeader>{t("Ajout d'une note")}</ModalHeader>

                        <ModalCloseButton />
                        <ModalBody pb={6}>
                            {message &&
                                <Alert mb={2} fontSize={"sm"} padding={2} variant={"left-accent"} status='error' rounded="md">
                                    <AlertIcon />
                                    {message}
                                </Alert>
                            }
                            <Flex flexDirection={'column'} align={'center'}>

                                <Flex w="100%" flexDirection={'column'}>
                                    <FormControl isRequired mb={3}>
                                        <FormLabel>{t("Titre")}</FormLabel>
                                        <Input maxLength={50} name="type" onChange={e => setTitle(e.target.value)} placeholder={t('Titre de note...')} />
                                    </FormControl>
                                    <FormControl isRequired mb={3}>
                                        <FormLabel>{t("Message")}</FormLabel>
                                        <Textarea height={"100px"} resize={"none"} type='text' name="message" onChange={e => setContent(e.target.value)} placeholder={t('Message de note...')} />
                                    </FormControl>
                                    <FormControl isRequired >
                                        <FormLabel>{t("Cible")}</FormLabel>
                                        <Select value={selectedCible} onChange={handleCibleChange} placeholder={t('Sélectionner une option')}>
                                            {user.role === "AdminClient" && <option value="ManagerClient">{t("Manager")}</option>}
                                            <option value="RespoSuiviClient">{t("Centre d'appel")}</option>
                                            <option value="StockManagerClient">{t("Gestionnaire de stock")}</option>
                                            <option value="All">{t("Tous les membres")}</option>
                                        </Select>
                                    </FormControl>

                                    {selectedCible && selectedCible !== 'All' && usersList.length > 0 && (
                                        <FormControl mt={3}>
                                            <FormLabel>{t("Utilisateur spécifique (optionnel)")}</FormLabel>
                                            <Select value={selectedUserCible} onChange={(e) => setSelectedUserCible(e.target.value)} placeholder={t('Tous les utilisateurs de ce rôle')}>
                                                {usersList.map(u => (
                                                    <option key={u.id} value={u.id}>{u.first_name} {u.last_name}</option>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    )}

                                    <FormControl mt={3}>
                                        <FormLabel>{t("Business (optionnel)")}</FormLabel>
                                        <Select value={selectedBusiness} onChange={(e) => setSelectedBusiness(e.target.value)} placeholder={t('Général (Aucun business)')}>
                                            {businessesList.map(b => (
                                                <option key={b.id} value={b.id}>{b.name}</option>
                                            ))}
                                        </Select>
                                    </FormControl>


                                </Flex>
                            </Flex>

                        </ModalBody>

                        <ModalFooter>
                            {(!title || !content || !selectedCible)
                                ?
                                <Button colorScheme='blue' isDisabled
                                >
                                    {t("Ajouter")}
                                </Button>
                                :
                                <Button colorScheme='blue'
                                    onClick={AjoutNote}
                                >
                                    {t("Ajouter")}
                                </Button>
                            }
                        </ModalFooter>
                    </ModalContent>
                </Modal>
                :
                <Modal isOpen={isOpen} onClose={() => {
                    onClose()
                    setMessage('')
                    setSelectedCible('')
                    setSelectedBusiness('')
                    setTitle('')
                    setContent('')
                    setSelectedCible('')
                }}>
                    <ModalOverlay />

                    <ModalContent>

                        <ModalHeader>{t("Modification de note")}</ModalHeader>

                        <ModalCloseButton />
                        <ModalBody pb={6}>
                            {message &&
                                <Alert mb={2} fontSize={"sm"} padding={2} variant={"left-accent"} status='error' rounded="md">
                                    <AlertIcon />
                                    {message}
                                </Alert>
                            }
                            <Flex flexDirection={'column'} align={'center'}>

                                <Flex w="100%" flexDirection={'column'}>
                                    <FormControl isRequired mb={3}>
                                        <FormLabel>{t("Titre")}</FormLabel>
                                        <Input maxLength={50} defaultValue={noteData.title} name="title" onChange={e => setTitle(e.target.value)} placeholder={t('Titre de note...')} />
                                    </FormControl>
                                    <FormControl isRequired mb={3}>
                                        <FormLabel>{t("Message")}</FormLabel>
                                        <Textarea height={"100px"} defaultValue={noteData.content} resize={"none"} type='text' name="message" onChange={e => setContent(e.target.value)} placeholder={t('Message de note...')} />
                                    </FormControl>
                                    <FormControl isRequired >
                                        <FormLabel>{t("Cible")}</FormLabel>
                                        <Select value={selectedCible} onChange={handleCibleChange} placeholder={t('Sélectionner une option')}>
                                            <option value="ManagerClient">{t("Manager")}</option>
                                            <option value="RespoSuiviClient">{t("Centre d'appel")}</option>
                                            <option value="StockManagerClient">{t("Gestionnaire de stock")}</option>
                                            <option value="All">{t("Tous les membres")}</option>
                                        </Select>
                                    </FormControl>

                                    {selectedCible && selectedCible !== 'All' && usersList.length > 0 && (
                                        <FormControl mt={3}>
                                            <FormLabel>{t("Utilisateur spécifique (optionnel)")}</FormLabel>
                                            <Select value={selectedUserCible} onChange={(e) => setSelectedUserCible(e.target.value)} placeholder={t('Tous les utilisateurs de ce rôle')}>
                                                {usersList.map(u => (
                                                    <option key={u.id} value={u.id}>{u.first_name} {u.last_name}</option>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    )}

                                    <FormControl mt={3}>
                                        <FormLabel>{t("Business (optionnel)")}</FormLabel>
                                        <Select value={selectedBusiness} onChange={(e) => setSelectedBusiness(e.target.value)} placeholder={t('Général (Aucun business)')}>
                                            {businessesList.map(b => (
                                                <option key={b.id} value={b.id}>{b.name}</option>
                                            ))}
                                        </Select>
                                    </FormControl>


                                </Flex>
                            </Flex>

                        </ModalBody>

                        <ModalFooter>


                            <Button colorScheme='blue'
                                onClick={() => UpdateNote(noteId)}
                            >
                                {t("Modifier")}
                            </Button>

                        </ModalFooter>
                    </ModalContent>
                </Modal>
            }

        </Box>
    )
}

export default GestNotes